import React from 'react';
import { FileText, Image, File } from 'lucide-react';

export const getFileIcon = (type) => {
  if (type?.startsWith('image/')) return <Image className="w-4 h-4" />;
  if (type?.includes('pdf')) return <FileText className="w-4 h-4" />;
  return <File className="w-4 h-4" />;
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
